
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewaySettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GatewaySettings"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessPointExternalEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessPointExternalSsid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessPointExternalPreSharedKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightBrightness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightEmergencyBrightness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightEmergencyTimeout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightEmergencyInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightPingInterval"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewayConfigurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GatewayConfiguration"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewaySettingsFragment"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewayFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Gateway"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentDate"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewayConfigurationFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gatewayTargetConfiguration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppManagerGatewayConfigurationPanelGatewaySettingsFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":765}};
    doc.loc.source = {"body":"fragment AppManagerGatewayConfigurationPanelGatewaySettingsFragment on GatewaySettings {\n  accessPointExternalEnabled\n  accessPointExternalSsid\n  accessPointExternalPreSharedKey\n  lightDuration\n  lightBrightness\n  lightEmergencyBrightness\n  lightEmergencyTimeout\n  lightEmergencyInterval\n  lightPingInterval\n}\n\nfragment AppManagerGatewayConfigurationPanelGatewayConfigurationFragment on GatewayConfiguration {\n  ...AppManagerGatewayConfigurationPanelGatewaySettingsFragment\n}\n\nfragment AppManagerGatewayConfigurationPanelGatewayFragment on Gateway {\n  configuration {\n    deploymentDate\n    ...AppManagerGatewayConfigurationPanelGatewayConfigurationFragment\n  }\n  gatewayTargetConfiguration {\n    ...AppManagerGatewayConfigurationPanelGatewaySettingsFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppManagerGatewayConfigurationPanelGatewaySettingsFragment"] = oneQuery(doc, "AppManagerGatewayConfigurationPanelGatewaySettingsFragment");
        
        module.exports["AppManagerGatewayConfigurationPanelGatewayConfigurationFragment"] = oneQuery(doc, "AppManagerGatewayConfigurationPanelGatewayConfigurationFragment");
        
        module.exports["AppManagerGatewayConfigurationPanelGatewayFragment"] = oneQuery(doc, "AppManagerGatewayConfigurationPanelGatewayFragment");
        
